export default __webpack_public_path__ + "static/media/close-icon.55ca7320.svg";